export default function changePasswordTemporary(to, from, next) {
    if (to.meta.acceptTermUse) {
        const acceptTermUse = localStorage.getItem('term_use');
        if (acceptTermUse == 'false') {
            next('/accept-term-use');
        }
    }

    next();
}